import Vue from 'vue';
import transferCallback from './transfer-callback/transfer-callback.vue';
Vue.component('transfer-callback', transferCallback);
